import { BuilderTypes } from 'components/dashboard/constants';
import { BuilderType, FlowType } from '../types';
import pluralize from '../utils/pluralize';

const Routes = {
  // Internal relative paths
  AUTOMATIONS_FLOWS: '/automations/flows',
  CAMPAIGNS_FLOWS: '/campaigns/flows',
  FLOWS_CREATE: '/[flowType]/create', // Legacy campaigns or automations new route
  FLOWS_NEW: '/[flowType]/flows/new',
  FLOWS_NEW_DEPRECATED: '/flows/new?type=[flowType]', // Do not use - replace with FLOWS_NEW

  // External absolute paths
  AUTOMATION_FLOWS_GUIDE_LINK:
    'https://help.postscript.io/hc/en-us/articles/6526853626011-Guide-to-Automation-Flows',
  ARTICLES_GUIDE_TO_MESSAGE_DELIVERABILITY:
    'https://help.postscript.io/hc/en-us/articles/1260804631230-Guide-to-Message-Deliverability-and-Throughput#01GEPWC92KNWZ9M7P49DF30PX0',
  ARTICLES_GUIDE_TO_QUIET_HOURS:
    'https://help.postscript.io/hc/en-us/articles/9321080861211-Guide-to-Quiet-Hours',
  BOOK_A_DEMO_AI: 'https://postscript.io/book-a-demo-ai',
  AUTOMATION_FLOW_ACTIONS_LINK:
    'https://help.postscript.io/hc/en-us/articles/6526853626011-Guide-to-Automation-Flows#01G57P92R79AJP7Q78727N9E32',
  CAMPAIGN_APPROVAL_LINK:
    'https://help.postscript.io/hc/en-us/articles/17408652693019-Understanding-First-Campaign-Approval-Process#approval-process-timeline-0-1',
  CAMPAIGN_FLOW_ACTIONS_LINK:
    'https://help.postscript.io/hc/en-us/articles/4410969319067-Guide-to-Campaign-Flows#01G57P92R79AJP7Q78727N9E32',
  CAMPAIGN_FLOWS_GUIDE_LINK:
    'https://help.postscript.io/hc/en-us/articles/4410969319067-Guide-to-Campaign-Flows',
  CARD_BUTTONS_HELP: 'https://help.postscript.io/hc/en-us', // TODO: Update with final link
  SUGGESTED_ACTIONS_HELP: 'https://help.postscript.io/hc/en-us', // TODO: Update with final link
} as const;

/**
 * Generates a route for creating or editing flows based on the flow type and builder type.
 * Example:
 * flowsRoute(FlowTypes.CAMPAIGN, BuilderTypes.LEGACY)
 * returns '/campaigns/create'
 * flowsRoute(FlowTypes.AUTOMATION, BuilderTypes.NEW)
 * returns '/automations/flows/new'
 */
export const flowsRoute = (args: {
  flowType: FlowType;
  builderType?: BuilderType;
  queryString?: string;
}) => {
  const { flowType, builderType, queryString } = args;

  const pluralFlowType = pluralize(flowType, 2).toLowerCase();

  if (builderType === BuilderTypes.LEGACY) {
    return Routes.FLOWS_CREATE.replace('[flowType]', pluralFlowType);
  }
  const base = Routes.FLOWS_NEW.replace('[flowType]', pluralFlowType);
  return queryString ? `${base}?${queryString}` : base;
};

export default Routes;
